import { combineReducers } from "redux";
import { localEditStateReducer } from "./localEditStateReducer";
import { localMultiSelectStateReducer } from "./localMultiSelectStateReducer";
import { localQuantityStateReducer } from "./localQuantityStateReducer";
import { localSelectStateReducer } from "./localSelectStateReducer";
export const localStateReducer = combineReducers({
    edit: localEditStateReducer,
    select: localSelectStateReducer,
    multiSelect: localMultiSelectStateReducer,
    quantity: localQuantityStateReducer,
});
//# sourceMappingURL=localStateReducer.js.map